import { put, select } from 'redux-saga/effects';

import * as D from '../../deps';
import * as PlaybackUtils from '../../utils';

export function* startInitialPlayback(action) {
  // We need to avoid the race condition where a listener has started playing music
  // for the first time and the InitializePlayback component gets mounted in the
  // middle of starting the source, which cancels the original start source. This
  // causes parts of the workflow to fail, though the music plays in the end.
  if (yield select(PlaybackUtils.isSourceStarting)) {
    return;
  }

  const currentPathname = yield select(D.Utils.Route.getCurrentPathnameFromState);

  const shouldShowPA = yield select(D.Utils.Listener.showPremiumAccess);
  const showPAOnPath = D.Utils.Route.shouldShowPremiumAccessCoachmarkOnBSPPath(currentPathname);
  const shouldShowPremiumAccessCoachmarkOnBSPPath = shouldShowPA && showPAOnPath;

  const recommendedSourceResponse = yield select(
    PlaybackUtils.getRecommendedInitialSourceFromRouteData,
    action.data,
  );

  const { trackToken, sortOrder, stationId } = recommendedSourceResponse;
  let { sourceId, type } = recommendedSourceResponse;
  let pandoraId;
  let sourceType;
  let context;

  if (shouldShowPremiumAccessCoachmarkOnBSPPath) {
    ({ sourceType, pandoraId } = yield select(
      D.Utils.Route.getPandoraIdAndSourceTypeFromBackstagePath,
      currentPathname,
    ));
    if (pandoraId) {
      sourceId = pandoraId;
      type = sourceType;
      context = D.Constants.Ads.Rewards.ContextTypes.DEEP_LINK;
    }
  }

  // TODO: Unify SourceType and PandoraType, JIRA: WEBCLIENT-6409
  type = D.Constants.SourceTypes.PandoraTypes[type];
  const isAPSEnabled = yield select(D.Utils.Listener.isAPSPandoraStationEnabled);
  const hasArtistMessage = yield select(D.Utils.TunerVars.hasOnDemandArtistMessageData);

  const isTier2User = yield select(D.getInDomain('payments.selectors.productTierIsPlus'));
  const isTier3User = yield select(D.getInDomain('payments.selectors.hasPremiumPlan'));

  if (isTier2User || isTier3User) {
    const data = {
      experimentId: isTier2User
        ? D.Constants.Experiments.EXPERIMENT_GROUPS.stationAPST2Migration
        : D.Constants.Experiments.EXPERIMENT_GROUPS.stationAPST3Migration,
      treatmentId: isTier2User
        ? D.Constants.Experiments.TREATMENT_ARMS.stationAPST2Migration
        : D.Constants.Experiments.TREATMENT_ARMS.stationAPST3Migration,
    };
    yield put(D.getInDomain('analytics.actions.logAbExperimentDiversionPoint')(data));
  }

  if (
    isAPSEnabled &&
    (hasArtistMessage ||
      (recommendedSourceResponse.type === D.Constants.SourceTypes.SourceTypes.STATION &&
        sourceId &&
        !sourceId.startsWith(D.Constants.SourceTypes.PandoraTypes.USER_STATION)))
  ) {
    yield put(
      D.Actions.UseCases.startStation({
        stationId: sourceId,
        rerouteBasedOnTier: true,
        initialPlayback: true,
      }),
    );
  } else {
    yield put(
      D.Actions.UseCases.playResumeSource({
        id: sourceId,
        pandoraType: type,
        sortOrder,
        context,
        trackToken,
        dontIntercept: true,
        stationId,
      }),
    );
  }
}
